<template>

    <v-page>

        <v-page-header icon="fas fa-user-circle">
            <v-breadcrumb>
                <v-breadcrumb-item><router-link :to="{ name: 'campaigns-member' }">Campaign Member</router-link></v-breadcrumb-item>
                <v-breadcrumb-item>Events</v-breadcrumb-item>
            </v-breadcrumb>
        </v-page-header>

        <v-page-body>

            <v-page-section padded>
                <template #header>
                    <span>Member</span>
                    <v-identifier :uuid="member.id" />
                </template>
                <template #body>
                    <v-prop-list
                        class="w-50p"
                        :properties="{
                            'Name': member.customer.name,
                            'Email': member.customer.email,
                        }">
                    </v-prop-list>
                </template>
                <template #footer>
                    <v-button size="xs" btn-style="white" @click.native="viewCustomer">View Customer</v-button>
                </template>
            </v-page-section>

            <v-page-section padded>
                <template #title>
                    <span>{{ pagination | paginationTitle('Timeline (', ')') }}</span>
                </template>
                <template #body>
                    <v-table :selectable="false" bordered>
                        <thead>
                            <th>Date</th>
                            <th>Event</th>
                        </thead>
                        <tbody>
                            <tr v-for="e in events" :key="e.id">
                                <td>{{ e.created_at | dateTime }}</td>
                                <td>{{ e.title }}</td>
                            </tr>
                        </tbody>
                    </v-table>
                </template>
                <template #footer>
                    <v-pagination :count="pagination.last_page" @search="getEvents($event)" />
                </template>
            </v-page-section>

        </v-page-body>

    </v-page>

</template>

<script>

import axios from 'axios';
import CampaignMemberApi from '@api/CampaignMemberApi';

export default {

    data() {
        return {
            member: null,
            events: [],
            pagination: {},
        }
    },

    mounted() {
        this.$store.commit('loading', true);
        let requests = [
            CampaignMemberApi.getMember(this.$route.params.id),
            CampaignMemberApi.getEvents(this.$route.params.id),
        ];
        axios.all(requests)
            .then(axios.spread((resMember, resEvents) => {
                this.$store.commit('loading', false);
                this.member = resMember.data.data;
                this.events = resEvents.data.data;
                this.pagination = resEvents.data.pagination;
                this.$events.$emit('pageLoaded');
            }), () => {
                this.$store.commit('loading', false);
                this.$events.$emit('pageError');
            });
    },

    methods: {

        getEvents(page = 1) {
            window.scrollTo(0, 0);
            this.$store.commit('loading', true);
            CampaignMemberApi.getEvents(this.$route.params.id, { page: page })
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.events = response.data.data;
                    this.pagination = response.data.pagination;
                    window.scrollTo(0, 0);
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        viewCustomer() {
            this.$router.push({
                name: 'customer',
                params: { id: this.member.customer_id },
            });
        },

    },

}

</script>
